import { isLearningCriterion, isLegacyCriterion } from './assessment'
import PlanSvg from '../static/images/workskills/icon_plan.svg'
import FocusSvg from '../static/images/workskills/icon_focus.svg'
import EffortSvg from '../static/images/workskills/icon_effort.svg'
import DocumentSvg from '../static/images/workskills/icon_document.svg'
import colors from '../configuration/colors'
import { levelCutoffs } from './skills'

export const isActiveWorkSkill = criterion =>
  criterion.active &&
  !isLearningCriterion(criterion) &&
  !isLegacyCriterion(criterion)

export const getWorkSkillIconSvg = workSkill => {
  switch (workSkill?.id) {
    case 5:
      return FocusSvg
    case 6:
      return PlanSvg
    case 7:
      return EffortSvg
    case 8:
      return DocumentSvg
    default:
      return null
  }
}

export const getTierNumber = (rating, isAggregate) => isAggregate
  ? levelCutoffs.findIndex(upperBound => rating < upperBound)
  : Math.max(0, Math.ceil(rating) - 1)

const tierColors = [
  {
    color: '#D6F4E0',
    contrastColor: '#429577'
  },
  {
    color: '#7FDEA0',
    contrastColor: '#2A6651'
  },
  {
    color: '#5DB889',
    contrastColor: colors.white
  },
  {
    color: '#429577',
    contrastColor: colors.white
  }
]

const unstarted = isMentor => ({
  name: isMentor ? 'Not Started' : 'No Feedback',
  color: 'transparent',
  contrastColor: colors.dove,
  border: '#E1E1E1 1px solid',
  light: true // font weight
})

export const getWorkSkillTier = (rating, workSkill, isMentor, isAggregate) =>
  rating === null || rating < 0
    ? unstarted(isMentor).name
    : workSkill.artifact_assessment_criterium_tiers[getTierNumber(rating, isAggregate)].name

export const getWorkSkillTierDisplay = (rating, workSkill, isMentor, isAggregate) =>
  rating === null
    ? unstarted(isMentor)
    : {
      ...tierColors[getTierNumber(rating, isAggregate)],
      name: getWorkSkillTier(rating, workSkill, isMentor, isAggregate)
    }

export const getWorkSkillBEName = workSkillId => {
  switch (workSkillId) {
    case 5: return 'focus'
    case 6: return 'plan'
    case 7: return 'make_effort'
    case 8: return 'document'
    default: return ''
  }
}

export const getWorkSkillTiers = workSkill =>
  workSkill.artifact_assessment_criterium_tiers.map((t, i) => ({
    value: i + 1,
    label: t.name
  }))
